export default __webpack_public_path__ + "static/media/icon-locked.fe7374c7.svg";